/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_Contactcodetree2Inputs */

const en_tab_contactcodetree2 = /** @type {(inputs: Tab_Contactcodetree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Code Tree`)
};

const de_tab_contactcodetree2 = /** @type {(inputs: Tab_Contactcodetree2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Code-Baum`)
};

/**
* | output |
* | --- |
* | "Contact Code Tree" |
*
* @param {Tab_Contactcodetree2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const tab_contactcodetree2 = /** @type {((inputs?: Tab_Contactcodetree2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_Contactcodetree2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tab_contactcodetree2(inputs)
	return de_tab_contactcodetree2(inputs)
});
export { tab_contactcodetree2 as "tab_contactCodeTree" }